<template>
  <div class="container-fluid px-4 mt-4">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <h5 class="fw-bold mb-0">탈락자 현황</h5>
      <div class="d-flex align-items-center gap-2">
        <span class="text-muted small" v-if="selectedArea && flatLosers.length > 0">
          총 {{ flatLosers.length }}명
        </span>
      </div>
    </div>

    <div class="card shadow-sm mb-4">
      <div class="card-body p-4">
        <h6 class="fw-bold mb-3">주차장 선택</h6>
        <div class="mb-3">
          <select v-model="selectedArea" class="form-select" @change="fetchLosers">
            <option value="">-- 주차장 선택 --</option>
            <option v-for="a in areas" :key="a.AreaSeq" :value="a.AreaSeq">
              {{ a.AreaName }} ({{ a.AreaCode }})
            </option>
          </select>
        </div>
      </div>
    </div>

    <div v-if="selectedArea">
      <div v-if="loading" class="text-center py-5 text-muted">불러오는 중...</div>
      <div v-if="loadError" class="alert alert-danger">{{ loadError }}</div>

      <div v-for="group in loserGroups" :key="group.GroupSeq" class="card shadow-sm mb-4">
        <div class="card-body p-4">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <h6 class="fw-bold mb-0">
              {{ group.GroupName }} ({{ group.losers.length }}명) 
              <span class="ms-2 text-success">합격자({{ group.winnerCount }}명)</span>
              <span class="ms-2 text-info">면적({{ group.QuotaCount }}개)</span>
            </h6>
          </div>

          <div v-if="group.losers.length === 0" class="text-center text-muted py-4">
            탈락자가 없습니다.
          </div>

          <div v-else class="table-responsive">
            <table class="table table-hover align-middle table-sm">
              <thead class="table-dark">
                <tr>
                  <th style="width: 60px">#</th>
                  <th>순번</th>
                  <th>이름</th>
                  <th>차량번호</th>
                  <th>그룹명</th>
                  <th>전화번호</th>
                  <th>요금제</th>
                  <th>가격</th>
                  <th>할인</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(w, idx) in group.losers" :key="w.WaitingSeq">
                  <td class="text-muted small">{{ idx + 1 }}</td>
                  <td class="text-muted small">{{ w.WaitingNumber }}</td>
                  <td class="fw-500">{{ w.UserName }}</td>
                  <td class="font-monospace small">{{ w.CarNumber }}</td>
                  <td>{{ w.GroupName }}</td>
                  <td class="font-monospace small">{{ w.Tel }}</td>
                  <td>{{ w.FeeName }}</td>
                  <td>{{ w.Price?.toLocaleString() || 0 }}원</td>
                  <td>{{ w.DiscountName || '없음' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!selectedArea" class="text-center text-muted py-5">
      주차장을 선택하면 탈락자 목록이 표시됩니다.
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AdminParkingPassLotteryLoser',
  data() {
    return {
      areas: [],
      selectedArea: '',
      loserGroups: [],
      loading: false,
      loadError: null
    }
  },
  computed: {
    flatLosers() {
      return this.loserGroups.reduce((acc, group) => {
        return acc.concat(group.losers || [])
      }, [])
    }
  },
  mounted() {
    this.initializeAreas()
  },
  methods: {
    async initializeAreas() {
      await this.fetchAreas()
      if (this.areas.length > 0) {
        this.selectedArea = this.areas[0].AreaSeq
        await this.fetchLosers()
      }
    },
    async fetchAreas() {
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_BASE}/api/parking-areas`)
        this.areas = res.data
      } catch (e) {
        console.error('fetchAreas error:', e)
      }
    },
    async fetchLosers() {
      if (!this.selectedArea) {
        this.loserGroups = []
        return
      }
      this.loading = true
      this.loadError = null
      this.loserGroups = []
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_BASE}/api/parking-pass-waiting-losers?areaSeq=${this.selectedArea}`)
        const results = res.data || []
        this.loserGroups = results.map(group => ({
          GroupSeq: group.groupSeq,
          GroupName: group.groupName,
          QuotaCount: group.quotaCount,
          winnerCount: group.winnerCount,
          losers: (group.losers || []).map(w => ({
            WaitingSeq: w.WaitingSeq,
            UserName: w.UserName,
            CarNumber: w.CarNumber,
            Tel: w.Tel,
            WaitingNumber: w.WaitingNumber,
            GroupName: group.groupName,
            AreaName: this.areas.find(a => a.AreaSeq === parseInt(this.selectedArea))?.AreaName || '',
            FeeName: w.FeeName || '미정',
            Price: w.Price || 0,
            DiscountRate: w.DiscountRate || 0,
            DiscountName: w.DiscountName || '없음'
          }))
        }))
      } catch (e) {
        this.loadError = '탈락자 목록을 불러오지 못했습니다.'
        console.error('fetchLosers error:', e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.table {
  margin-bottom: 0;
}

.table tbody tr {
  border-bottom: 1px solid #e9ecef;
}

.table tbody tr:last-child {
  border-bottom: none;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border: none;
}

.fw-500 {
  font-weight: 500;
}
</style>
